module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header id="header" class="header"></header>\n<div id="match-centre-game-bar"></div>\n<div id="menu"></div>\n<div id="top-ads-container"></div>\n<main></main>\n<div id="ads-container"></div>\n<div id="footer"></div>\n<div id="coach-popup"></div>\n<div id="user-modal"></div>\n<div id="global-notification"></div>';
}
return __p;
};
